import React, { useCallback, useRef, useState } from 'react'

import Button from '../../../components/Button/Button'
import { Form } from '../../../components/Form/Form'
import Modal from '../../../components/Modal/Modal'
import ModalContent from '../../../components/Modal/ModalContent'
import ModalFooter from '../../../components/Modal/ModalFooter'
import ModalHeader from '../../../components/Modal/ModalHeader'
import PhotoUploader from '../../../components/PhotoUploader/PhotoUploader'
import TextField from '../../../components/TextField/TextField'
import t from '../../../helpers/i18n'

const InviteMemberFormModal = ({ onCloseRequested }) => {
  const [formValid, setFormValid] = useState(false)
  const inviteMemberData = useRef()

  const handleSave = useCallback((target) => {}, [])

  return (
    <Modal onCloseRequested={onCloseRequested}>
      <ModalHeader title={t('modal_headers.Invite_a_new_member')} />
      <Form data={inviteMemberData} onValidityChange={setFormValid}>
        <ModalContent>
          <div className='overline-label-large-medium'>
            {t('titles.Personal_Information')}
          </div>
          <TextField
            name='firstname'
            label={t('labels.Given_name(s)')}
            type='proper-noum'
            size='field-sized'
            maxLength={100}
            minLength={1}
            required
          />
          <TextField
            name='lastname'
            label={t('labels.Family_name(s)')}
            type='proper-noum'
            size='field-sized'
            maxLength={100}
            minLength={1}
            required
          />
          <PhotoUploader label={t('labels.Photo')} hint={t('labels.(Optional)')} />
          <TextField
            name='birthday'
            label={t('labels.Date_of_birth')}
            type='simple'
            size='field-sized'
            maxLength={100}
            minLength={1}
            required
          />
        </ModalContent>
        <ModalContent>
          <div className='overline-label-large-medium'>
            {t('titles.Legal_Guardians_Account')}
          </div>
          <TextField
            name='email'
            label={t('labels.Email_address')}
            type='proper-noum'
            size='field-sized'
            maxLength={100}
            minLength={1}
            required
          />
          <TextField
            name='lastname'
            label={t('labels.Mobile_number')}
            type='proper-noum'
            size='field-sized'
            maxLength={100}
            minLength={1}
            required
          />
          <TextField
            name='birthday'
            label={t('labels.Date_of_birth')}
            type='simple'
            size='field-sized'
            maxLength={100}
            minLength={1}
            required
          />
        </ModalContent>
      </Form>
      <ModalFooter>
        <Button
          disabled={!formValid}
          onClick={(event) => handleSave(event.currentTarget)}
          label={t('buttons.Invite')}
          grow
        />
      </ModalFooter>
    </Modal>
  )
}

export default InviteMemberFormModal
